import React from "react";
import { BsArrowDownShort, BsArrowUpShort } from "react-icons/bs";
import TooltipGeneric from "../../../../shared/components/generic/tooltip/tooltip-generic";
import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";
import {
	getTrendClassName,
	getTrendLabel,
	hasTrend,
	isFallingTrend
} from "../../utils/dashboard-trend-utils";
import "./sales-summary.css";

const DashboardMonthlySalesSummary = ({
	monthlySales = {},
	cycleStatus = {},
	isClosedCycle = false
}) => {
	const monthlyDiscountPercentage = monthlySales?.discountPercentage ?? 0;
	const monthlyTrend = monthlySales?.trend || monthlySales?.tendencia;
	const isMonthlyFalling = isFallingTrend(monthlyTrend);
	const TrendIcon = isMonthlyFalling ? BsArrowDownShort : BsArrowUpShort;

	if (isClosedCycle) {
		return (
			<div className="dashboard-sales-summary dashboard-sales-summary--closed-cycle">
				<div className="dashboard-sales-summary__discount">
					<span>Desconto alcançado no ciclo:</span>

					<strong className="dashboard-percentage-pill">
						{MonetaryUtils.formatPercentage(monthlyDiscountPercentage)}
					</strong>

					<TooltipGeneric
						content="Opção para justificar resultado final."
						iconSize={16}
						placement="top"
					/>
				</div>

				<div className="dashboard-sales-summary__metrics">
					<p>
						<span>Média de vendas no ciclo:</span>
						<strong>
							{MonetaryUtils.formatCurrency(
								monthlySales?.projectedAccumulatedAverage ?? 0
							)}
						</strong>
					</p>
				</div>
			</div>
		);
	}

	return (
		<div className="dashboard-sales-summary">
			<div className="dashboard-sales-summary__discount">
				<span>Projeção de desconto no ciclo:</span>

				<strong className="dashboard-percentage-pill">
					{MonetaryUtils.formatPercentage(monthlyDiscountPercentage)}
				</strong>

				<TooltipGeneric
					content="Opção para justificar resultado final."
					iconSize={16}
					placement="top"
				/>
			</div>

			<div className="dashboard-sales-summary__metrics">
				<p>
					<span>Vendas atuais no mês:</span>
					<strong>
						{MonetaryUtils.formatCurrency(monthlySales?.accumulatedMonth ?? 0)}
					</strong>
				</p>

				<p className="dashboard-sales-summary__metric--highlight">
					<span className="dashboard-sales-summary__metric-main">
						<span>Projeção de média acumulada no fim do mês:</span>

						<span className="dashboard-sales-summary__metric-result">
							<strong>
								{MonetaryUtils.formatCurrency(
									monthlySales?.endMonthProjection ?? 0
								)}
							</strong>

							{hasTrend(monthlyTrend) && (
								<span className={getTrendClassName(monthlyTrend)}>
									<TrendIcon size={18} />
									<span>{getTrendLabel(monthlyTrend)}</span>
								</span>
							)}
						</span>
					</span>
				</p>
			</div>
		</div>
	);
};

export default DashboardMonthlySalesSummary;